import React, { useEffect, useState } from "react";
import { getLiveChatAgents, ILiveChatAgentUser } from "../live-chat-module/services/liveChatAgent";
import CreateLiveChatAgentModal from "./CreateLiveChatAgentModal";

function getInitials(name: string, surname: string) {
  return `${name?.[0] ?? ""}${surname?.[0] ?? ""}`.toUpperCase();
}

function formatRoleName(role: string) {
  return role.replace(/^Mutfacik/i, "").replace(/([a-z])([A-Z])/g, "$1 $2");
}

export default function LiveChatUsersTab() {
  const [agents, setAgents] = useState<ILiveChatAgentUser[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [search, setSearch] = useState("");
  const [selectedAgent, setSelectedAgent] = useState<ILiveChatAgentUser | null>(null);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const fetchAgents = () => {
    setLoading(true);
    setError(null);
    getLiveChatAgents()
      .then((res) => setAgents(res.data))
      .catch(() => setError("LiveChat kullanıcıları yüklenirken bir hata oluştu."))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchAgents();
  }, []);

  const filtered = agents.filter((a) => {
    const q = search.toLowerCase();
    return (
      a.customerName.toLowerCase().includes(q) ||
      a.customerSurName.toLowerCase().includes(q) ||
      a.customerEmail.toLowerCase().includes(q) ||
      a.customerTelNo.toLowerCase().includes(q)
    );
  });

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12, marginBottom: 20 }}>
        <div style={{
          background: "#eef2ff", borderRadius: 12, padding: "8px 16px",
          fontWeight: 700, color: "#4f46e5", fontSize: "0.85rem"
        }}>
          Toplam: {agents.length} kullanıcı
        </div>
        <button
          onClick={() => setShowCreateModal(true)}
          style={{
            padding: "8px 18px", borderRadius: 10, border: "none",
            background: "linear-gradient(135deg, #6366f1, #4f46e5)",
            color: "#fff", fontWeight: 700, fontSize: "0.85rem",
            cursor: "pointer", display: "flex", alignItems: "center", gap: 7,
            boxShadow: "0 4px 12px rgba(99,102,241,0.3)",
          }}
        >
          <i className="bi bi-person-plus-fill"></i> Kullanıcı Yarat
        </button>
      </div>

      {/* Search */}
      <div style={{ position: "relative", marginBottom: 20, maxWidth: 400 }}>
        <i className="bi bi-search" style={{
          position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)",
          color: "#9ca3af", fontSize: "0.9rem"
        }}></i>
        <input
          type="text"
          placeholder="İsim, e-posta veya telefon ara..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            width: "100%", padding: "10px 12px 10px 36px",
            border: "1.5px solid #e5e7eb", borderRadius: 10,
            fontSize: "0.88rem", outline: "none", background: "#fff",
            boxSizing: "border-box"
          }}
        />
      </div>

      {/* States */}
      {loading && (
        <div style={{ textAlign: "center", padding: "60px 0", color: "#6b7280" }}>
          <div className="spinner-border text-primary" role="status" style={{ width: 36, height: 36 }} />
          <p style={{ marginTop: 12, fontSize: "0.9rem" }}>Kullanıcılar yükleniyor...</p>
        </div>
      )}

      {error && (
        <div style={{
          background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 12,
          padding: "16px 20px", color: "#dc2626", display: "flex", alignItems: "center", gap: 10
        }}>
          <i className="bi bi-exclamation-triangle-fill"></i> {error}
        </div>
      )}

      {/* Agent Cards */}
      {!loading && !error && (
        <>
          {filtered.length === 0 ? (
            <div style={{ textAlign: "center", padding: "60px 0", color: "#9ca3af" }}>
              <i className="bi bi-headset" style={{ fontSize: "2.5rem" }}></i>
              <p style={{ marginTop: 12 }}>LiveChat kullanıcısı bulunamadı.</p>
            </div>
          ) : (
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
              gap: 16
            }}>
              {filtered.map((agent) => (
                <div key={agent.userId}
                  onClick={() => setSelectedAgent(agent)}
                  style={{
                    background: "#fff",
                    border: "1.5px solid #e5e7eb",
                    borderRadius: 16,
                    padding: "20px",
                    cursor: "pointer",
                    transition: "box-shadow 0.2s, border-color 0.2s",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.06)"
                  }}
                  onMouseEnter={e => {
                    (e.currentTarget as HTMLDivElement).style.boxShadow = "0 6px 20px rgba(99,102,241,0.15)";
                    (e.currentTarget as HTMLDivElement).style.borderColor = "#c7d2fe";
                  }}
                  onMouseLeave={e => {
                    (e.currentTarget as HTMLDivElement).style.boxShadow = "0 1px 4px rgba(0,0,0,0.06)";
                    (e.currentTarget as HTMLDivElement).style.borderColor = "#e5e7eb";
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 14 }}>
                    {/* Avatar */}
                    <div style={{ position: "relative", flexShrink: 0 }}>
                      <div style={{
                        width: 46, height: 46, borderRadius: "50%",
                        background: "linear-gradient(135deg, #6366f1, #4f46e5)",
                        color: "#fff", display: "flex", alignItems: "center",
                        justifyContent: "center", fontWeight: 800, fontSize: "1rem",
                      }}>
                        {getInitials(agent.customerName, agent.customerSurName)}
                      </div>
                      <span title={agent.isOnCallActive ? "Görüşmede" : agent.isOnCall ? "Çağrıda" : "Müsait"} style={{
                        position: "absolute", right: -2, bottom: -2,
                        width: 14, height: 14, borderRadius: "50%",
                        border: "2px solid #fff",
                        background: agent.isOnCallActive ? "#f59e0b" : agent.isOnCall ? "#3b82f6" : "#22c55e",
                      }} />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 700, color: "#111827", fontSize: "0.95rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {agent.customerName} {agent.customerSurName}
                      </div>
                      <div style={{ fontSize: "0.78rem", color: "#6b7280", marginTop: 2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {agent.customerEmail || "-"}
                      </div>
                    </div>
                    {/* Status badge */}
                    <span style={{
                      fontSize: "0.7rem", fontWeight: 700, padding: "3px 10px",
                      borderRadius: 20, flexShrink: 0,
                      background: agent.isEnabled ? "#dcfce7" : "#fee2e2",
                      color: agent.isEnabled ? "#16a34a" : "#dc2626"
                    }}>
                      {agent.isEnabled ? "Aktif" : "Pasif"}
                    </span>
                  </div>

                  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                    <InfoRow icon="bi-telephone" label={agent.customerTelNo || "-"} />
                    <div style={{ display: "flex", gap: 6, marginTop: 4, flexWrap: "wrap" }}>
                      {agent.roles.map((role) => (
                        <span key={role} style={{
                          display: "inline-flex", alignItems: "center", gap: 4,
                          fontSize: "0.7rem", fontWeight: 600, padding: "3px 8px", borderRadius: 20,
                          background: "#f5f3ff", color: "#6366f1",
                        }}>
                          <i className="bi bi-headset"></i> {formatRoleName(role)}
                        </span>
                      ))}
                      <StatusBadge
                        ok={agent.isOnCallActive}
                        label="Görüşmede"
                        icon="bi-telephone-inbound"
                      />
                      <StatusBadge
                        ok={agent.isOnCall}
                        label="Çağrıda"
                        icon="bi-broadcast"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {/* Detail Modal */}
      {selectedAgent && (
        <AgentDetailModal agent={selectedAgent} onClose={() => setSelectedAgent(null)} />
      )}

      {/* Create Modal */}
      {showCreateModal && (
        <CreateLiveChatAgentModal
          onClose={() => setShowCreateModal(false)}
          onSuccess={fetchAgents}
        />
      )}
    </div>
  );
}

function InfoRow({ icon, label }: { icon: string; label: string }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#4b5563", fontSize: "0.82rem" }}>
      <i className={`bi ${icon}`} style={{ color: "#9ca3af", width: 16, textAlign: "center" }}></i>
      {label}
    </div>
  );
}

function StatusBadge({ ok, label, icon }: { ok: boolean; label: string; icon: string }) {
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 4,
      fontSize: "0.7rem", fontWeight: 600, padding: "3px 8px", borderRadius: 20,
      background: ok ? "#dcfce7" : "#f3f4f6",
      color: ok ? "#16a34a" : "#9ca3af"
    }}>
      <i className={`bi ${icon}`}></i> {label}
    </span>
  );
}

function AgentDetailModal({ agent, onClose }: { agent: ILiveChatAgentUser; onClose: () => void }) {
  return (
    <>
      <div onClick={onClose} style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)",
        backdropFilter: "blur(4px)", zIndex: 1040
      }} />
      <div style={{
        position: "fixed", top: "50%", left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#fff", borderRadius: 20, zIndex: 1050,
        width: "min(560px, 95vw)", maxHeight: "85vh", overflowY: "auto",
        boxShadow: "0 20px 60px rgba(0,0,0,0.2)", padding: "28px",
        boxSizing: "border-box",
      }}>
        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 24 }}>
          <div style={{
            width: 56, height: 56, borderRadius: "50%",
            background: "linear-gradient(135deg, #6366f1, #4f46e5)",
            color: "#fff", display: "flex", alignItems: "center",
            justifyContent: "center", fontWeight: 800, fontSize: "1.2rem", flexShrink: 0
          }}>
            {getInitials(agent.customerName, agent.customerSurName)}
          </div>
          <div style={{ flex: 1 }}>
            <h5 style={{ margin: 0, fontWeight: 800, color: "#111827" }}>
              {agent.customerName} {agent.customerSurName}
            </h5>
            <span style={{
              fontSize: "0.75rem", fontWeight: 700, padding: "2px 10px",
              borderRadius: 20, marginTop: 4, display: "inline-block",
              background: agent.isEnabled ? "#dcfce7" : "#fee2e2",
              color: agent.isEnabled ? "#16a34a" : "#dc2626"
            }}>
              {agent.isEnabled ? "Aktif" : "Pasif"}
            </span>
          </div>
          <button onClick={onClose} style={{
            background: "#f3f4f6", border: "none", borderRadius: "50%",
            width: 36, height: 36, cursor: "pointer", color: "#6b7280",
            display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1rem"
          }}>
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        {/* Info Grid */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12, marginBottom: 20 }}>
          <DetailField label="E-posta" value={agent.customerEmail || "-"} icon="bi-envelope" />
          <DetailField label="Telefon" value={agent.customerTelNo || "-"} icon="bi-telephone" />
          <DetailField label="Kullanıcı ID" value={agent.userId} icon="bi-key" />
          <DetailField label="Roller" value={agent.roles.map(formatRoleName).join(", ") || "-"} icon="bi-person-badge" />
        </div>

        {/* Çağrı Durumu */}
        <div style={{ background: "#f8faff", borderRadius: 12, padding: "14px 16px" }}>
          <div style={{ fontWeight: 700, fontSize: "0.82rem", color: "#374151", marginBottom: 10 }}>
            <i className="bi bi-headset me-2" style={{ color: "#6366f1" }}></i>Çağrı Durumu
          </div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <StatusBadge ok={agent.isEnabled} label="Kullanıcı Aktif" icon="bi-toggle-on" />
            <StatusBadge ok={agent.isOnCall} label="Çağrıda" icon="bi-broadcast" />
            <StatusBadge ok={agent.isOnCallActive} label="Görüşme Devam Ediyor" icon="bi-telephone-inbound" />
          </div>
        </div>
      </div>
    </>
  );
}

function DetailField({ label, value, icon }: { label: string; value: string; icon: string }) {
  return (
    <div style={{ background: "#f8faff", borderRadius: 10, padding: "10px 12px" }}>
      <div style={{ fontSize: "0.72rem", color: "#9ca3af", fontWeight: 600, marginBottom: 3 }}>
        <i className={`bi ${icon} me-1`}></i>{label}
      </div>
      <div style={{ fontSize: "0.85rem", fontWeight: 600, color: "#111827", wordBreak: "break-all" }}>
        {value}
      </div>
    </div>
  );
}
